const localityCounty = row => (row.county && row.county.name) || "—";

export default {
  slug: "localities",
  endpoint: "localities/",
  titleKey: "localities_title",
  subtitleKey: "localities_sub",
  columns: [
    { field: "name", label: "f_name" },
    { label: "f_county", format: localityCounty },
  ],
  filters: [{ name: "county", entity: "county", label: "f_county", defaultRegion: true }],
  fields: [
    { name: "name", type: "text", label: "f_name", required: true },
    { name: "county", type: "entity", entity: "county", label: "f_county", required: true },
    { name: "additional_info", type: "keyvalue", label: "f_additional_info", wide: true },
  ],
  softDelete: true,
};
